import React from 'react'

const SubHeading = ({children}) => <p className='dashboard-sub-heading'>{children}</p>

export default SubHeading